export default __webpack_public_path__ + "static/media/privacyPolicy.ebee402a.md";